import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionFourImagesVerticalBody,
    SectionFourImagesVerticalDetails,
} from "types/api/blocks/sectionFourImagesVertical";

function useSectionFourImagesVerticalApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionFourImagesVertical = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionFourImagesVerticalDetails> => {
        return get<PathParamsWithId, undefined, SectionFourImagesVerticalDetails>({
            url: "/blocks/section-four-images-vertical/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionFourImagesVertical = React.useCallback((body: SectionFourImagesVerticalBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionFourImagesVerticalBody, null>({
            url: "/blocks/section-four-images-vertical",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionFourImagesVertical = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-four-images-vertical/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionFourImagesVertical,
        saveSectionFourImagesVertical,
        deleteSectionFourImagesVertical
    };
}

export default useSectionFourImagesVerticalApi;